<template>
  <div>
    <div id="wrapper">
      <img src="../assets/my/2026.png" style="height:120px;"/>
      <div id="content" style="height:690px;">
        <p style="font-size:large; float:none;">
          <strong>Paper Submission</strong>
        </p>
        <p style="font-size:large; float:none;">
          Please submit a full-length paper (8 page IEEE 2-column format) through the online submission system. Electronic submissions in pdf format are required.
        </p>
        <p style="font-size:large; float:none;">
          <strong>Online Submission</strong>
        </p>
        <p style="font-size:large; float:none;">
          Please submit your paper through the <a href="https://wi-lab.com/cyberchair/2026/bibm26/index.php" target="_blank" rel="noopener">BIBM 2026 online submission system</a>.
        </p>

        <p style="font-size:large; float:none;">
          <strong>Key Dates</strong>
        </p>
        <table width="100%" border="0" cellspacing="4" cellpadding="0">
          <tr>
            <td><span class="my-c">Paper submission deadline:</span></td>
          </tr>
          <tr>
            <td><span class="my-c">Sept&nbsp;27,&nbsp;2026</span></td>
          </tr>
          <tr><td>&nbsp;</td></tr>
          <tr>
            <td><span class="my-c">Paper acceptance notification:</span></td>
          </tr>
          <tr>
            <td><span class="my-c">Oct&nbsp;18,&nbsp;2026</span></td>
          </tr>
          <tr><td>&nbsp;</td></tr>
          <tr>
            <td><span class="my-c">Camera-ready manuscript due:</span></td>
          </tr>
          <tr>
            <td><span class="my-c">Nov&nbsp;8,&nbsp;2026</span></td>
          </tr>
          <tr><td>&nbsp;</td></tr>
          <tr>
            <td><span class="my-c">Workshop dates:</span></td>
          </tr>
          <tr>
            <td><span class="my-c">Dec&nbsp;1-4,&nbsp;2026</span></td>
          </tr>
        </table>
        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
